import React from 'react';
import "./input.scss";
import {save} from "./saver";

interface InputInterface {
    id: string;
    label: string;
    placeholder: string;
    type?: string;
    alert_message?: string;
    is_required: boolean;
}

interface InputState {
    value?: string;
    callback: any;
    message_shown: boolean;
    input_class: string;
}

const InputClass = {
    default: 'input-default',
    message: 'input-default input-message'
}

export class InputFactory extends React.Component<InputInterface, InputState>
{
    private callback: any;

    // @ts-ignore
    constructor(props) {
        super(props)

        this.state = {
            callback: 'empty_state',
            message_shown: false,
            input_class: 'input-default'
        }   ;
    }

    get id() {
        return this.props.id
    }

    get value() {
        return this.state.value
    }

    setValue = (value: string): void => {
        this.setState({
          value: value
        }, () => this.validateInput.bind(this)() )
    }

    validateInput = (): void => {
        this.setState({
            message_shown: !this.value,
            input_class: this.props.is_required ? (this.value ? InputClass.default : InputClass.message) : InputClass.default
        }, () => console.log(this) )

        save(this)
    }

    render() {
        const { id, placeholder, label, type, alert_message, is_required } = this.props;
        const { message_shown, input_class } = this.state;

        return <div className={"input_field"}>
            <div className={"input_field_label"}>
                <label
                    htmlFor={id}
                >
                    {label}
                </label>
            </div>
            <input
                className={input_class}
                id={id}
                placeholder={placeholder}
                type={type}
                required={is_required}
                onChange={ (e) => this.setValue.bind(this)(e.target.value)}
            />
            { message_shown && is_required ? <div className={"input_field_label_message"}>
                { alert_message }
            </div> : null }
        </div>
    }
}
